module.exports = __webpack_public_path__ + "img/h_cobalt_main.jpg";